import { getWelcomeTeamForHostnameRequest } from "../axios/routes/teamHostname";
import { StorageServiceInstance } from "../services/storage";
import { getRequestFanHost } from "./fanFlowNavigation";

/** Load the team, and a game and seat when the preview URL has them. */
export async function bootstrapFlowPreview(): Promise<void> {
  const params = new URLSearchParams(window.location.search);
  if (params.get("flowPreview") !== "1") return;
  const host = getRequestFanHost();
  if (host) {
    try {
      const resolved = await getWelcomeTeamForHostnameRequest(host);
      if ("team" in resolved && resolved.team) {
        StorageServiceInstance.applyWelcomeTeam(resolved.team);
      }
    } catch {
      // The page can still render from team context already stored in this tab.
    }
  }
  const gameId = (params.get("gameId") || "").trim();
  if (!gameId) return;
  const section = params.get("section") || "";
  const row = params.get("row") || "";
  const seat = params.get("seat") || "";
  try {
    await StorageServiceInstance.loadGameWithSeat(gameId, section, row, seat);
  } catch {
    // A missing game or seat should not block the user-details preview.
  }
}
